import React, {useRef, useState, useCallback, useEffect, useMemo} from 'react';
import {useMutation} from 'react-query';
import {toast} from 'react-toastify';
import {PinInput} from '../../components/PinInput';
import {logo} from '../../assets/images/images';
import {verify2FA} from '../../requests/queries/settings';

const OTP_LENGTH = 6;
const OTP_ARRAY = Array(OTP_LENGTH).fill('');

export const ValidateOTP = ({
  onComplete,
  user,
  src,
  noLogo,
  spinnerClassName,
}) => {
  const [otp, setOtp] = useState(OTP_ARRAY);
  const otpRefs = useRef([]);

  const {mutate, isLoading} = useMutation(verify2FA, {
    onSuccess: data => {
      onComplete(data);
      toast.success(data?.message);
      setOtp(OTP_ARRAY);
    },
    onError: error => {
      toast.error(error.response.data.error);
      setOtp(OTP_ARRAY);
    },
  });

  const handlePaste = useCallback((e, currentPin, setCurrentPin) => {
    e.preventDefault();
    const pastedData = e.clipboardData
      .getData('text')
      .replace(/\D/g, '')
      .slice(0, OTP_LENGTH);
    const newPin = [...currentPin];
    for (let i = 0; i < pastedData?.length; i++) {
      newPin[i] = pastedData[i];
    }
    setCurrentPin(newPin);
    if (pastedData?.length === OTP_LENGTH) {
      otpRefs.current[OTP_LENGTH - 1]?.focus();
    } else {
      otpRefs.current[pastedData?.length]?.focus();
    }
  }, []);
  const handleInputChange = useCallback(
    (e, index, currentPin, setCurrentPin) => {
      const value = e.target.value.replace(/\D/g, '');
      if (value.length <= 1) {
        const newPin = [...currentPin];
        newPin[index] = value;
        setCurrentPin(newPin);

        if (value && index < OTP_LENGTH - 1) {
          otpRefs.current[index + 1]?.focus();
        }
      }
    },
    [],
  );
  useEffect(() => {
    otpRefs.current[0]?.focus();
  }, []);

  const handleKeyDown = useCallback((e, index, currentPin) => {
    if (e.key === 'Backspace' && !currentPin[index] && index > 0) {
      otpRefs.current[index - 1]?.focus();
    }
  }, []);
  const isValid = useMemo(() => otp.join('').length === OTP_LENGTH, [otp]);

  const handleVerify = useCallback(() => {
    try {
      const data = {
        id: user?.id,
        token: otp?.join(''),
      };

      mutate(data);
    } catch (e) {
      console.log(e);
    }
  }, [mutate, otp, user?.id]);

  useEffect(() => {
    if (isValid) {
      handleVerify();
    }
  }, [handleVerify, isValid]);

  return (
    <div className="w-[75%] relative">
      {!noLogo && (
        <img src={src || logo} alt="Dojah logo" className="max-h-[50px]" />
      )}
      <div
        className="flex flex-col items-start gap-3 text-left"
        style={{
          opacity: isLoading ? 0.2 : 1,
        }}
      >
        <p className="   mt-10 text-grey text-xl font-medium ">
          Validate 2FA OTP
        </p>
        <span className="text-sm text-body w-[400px]">
          A code has been generated on your authenticator app, enter the OTP
          code below
        </span>
        <PinInput
          pin={otp}
          onChange={(e, index) => handleInputChange(e, index, otp, setOtp)}
          onKeyDown={(e, index) => handleKeyDown(e, index, otp)}
          onPaste={e => handlePaste(e, otp, setOtp)}
          pinRefs={otpRefs}
          show
          rounded="rounded"
          justify="justify-start"
        />
      </div>

      {/*<div className="flex items-center mt-6">*/}
      {/*  <PrimaryButton*/}
      {/*    buttonText="Validate OTP"*/}
      {/*    className="w-full rounded-lg"*/}
      {/*    onClick={handleVerify}*/}
      {/*    disabled={!isValid}*/}
      {/*    loading={isLoading}*/}
      {/*  />*/}
      {/*</div>*/}

      {isLoading && (
        <div
          className={`${spinnerClassName} absolute flex justify-center w-[75%] -bottom-12 items-center mb-2`}
        >
          <span className="text-sm mr-3 italic  text-batchBlue">
            Validating...
          </span>
          <div className="spinner "></div>
        </div>
      )}
    </div>
  );
};
